<template>
    <div>
        <h1 class="display-heading">Verify Email Address</h1>

        <p v-if="hasResult" v-html="verifyMessage">
        </p>

        <template v-if="hasResult">
            <template v-if="verifySuccess">
                <router-link class="btn btn-primary btn-primary-insv" :to="{'name': 'login'}">Login Now</router-link>
            </template>
            <template v-else>
                <template v-if="!verifyHasError">
                     <p>If you believe this is shouldn't happen,
                        please <a href="javascript:void(0);" @click="requestNewVerificationEmail">click here</a> to request for a new activation email.
                    </p>
                </template>
                <router-link class="btn btn-primary btn-primary-insv" :to="{'name': 'login'}">Back to Login Page</router-link>
            </template>
        </template>

        <popup-modal ref="popupRequestVerificationEmail" :hasCloseButton="false" title="Request for a New Activation Email">
            <template slot="content">
                <form ref="form" @submit.prevent="submitRequestConfirmationEmail">
                <template v-if="successRequestActivationEmail">
                    <p>An activation email has been sent to your email address, {{ form.emailAddress }}.</p>
                    <p>
                        Please click on the confirmation link in the email to activate your new account.
                    </p>
                </template>
                <template v-else>
                    <div class="form-group required">
                        <label>Email Address</label>

                        <input type="text" name="email" ref="email" data-vv-validate-on="blur"
                            placeholder="Enter your email address" v-model="form.emailAddress" v-validate="'required|email'"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('email')
                            }">

                        <div v-show="validationErrors.has('email')" class="invalid-feedback">
                            {{ validationErrors.first('email') }}
                        </div>
                    </div>
                </template>
                </form>
            </template>
            <template slot="footer">
                <button v-if="successRequestActivationEmail" type="button" class="btn btn-primary btn-primary-insv" @click="backToLogin">Okay</button>
                <template v-else>
                    <button @click="submitRequestConfirmationEmail" class="btn btn-primary btn-primary-insv">Submit</button>
                    <button type="button" class="btn btn-secondary" @click="dismissPopup">
                    Discard
                </button>
               </template>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
export default {
    'name': 'ForgotPassword',
    'components': {
        popupModal
    },
    'computed': {
        token () {
            return this.$route.query && this.$route.query.token;
        }
    },
    data () {
        return {
            'hasResult': false,
            'verifyMessage': '',
            'verifySuccess': false,
            'verifyHasError': false,
            'form': {
                'emailAddress': null
            },
            'successRequestActivationEmail': false
        };
    },
    mounted () {
        this.verifyEmail();
    },
    'methods': {
        verifyEmail () {
            this.axios.get('Account/VerifyEmail', {
                'params': {
                    'token': this.token
                }
            }).then(({ data }) => {
                const status = data.data.status;

                if (status) {
                    if (status === 1) {
                        this.verifySuccess = true;
                        this.verifyMessage = 'Account activated! Login to your new account now.';
                    } else if (status === 2) {
                        this.verifyMessage = 'Error verifying your email address. Activation link expired.';
                    }
                } else {
                    this.verifyMessage = 'Error verifying your email address. Invalid link.';
                }
            }).catch(() => {
                this.verifyHasError = true;
                this.verifyMessage = 'Error verifying your email address. Please refresh this page to try again.';
            }).finally(() => {
                this.hasResult = true;
            });
        },
        submitRequestConfirmationEmail () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    let payload = {
                        'emailAddress': this.form.emailAddress
                    };

                    this.axios.post('Account/RequestVerificationEmail', payload).then(() => {
                        this.successRequestActivationEmail = true;
                    }).catch(() => {

                    });
                }
            });
        },
        backToLogin () {
            this.$refs.popupRequestVerificationEmail.hide().then(() => {
                this.$router.push({ 'name': 'login' });
            });
        },
        dismissPopup () {
            this.$refs.popupRequestVerificationEmail.hide();
        },
        requestNewVerificationEmail () {
            this.$refs.popupRequestVerificationEmail.show();
        }
    }
};

</script>

<style>

</style>
